import PropTypes from "prop-types"
import React from "react"
import classNames from "classnames"
import { GatsbyImage } from "gatsby-plugin-image"

import PhotoCount from "../PhotoCount/PhotoCount"
import VideoCount from "../VideoCount/VideoCount"

import {
  image as imageStyles,
  imageWithCountContainer,
  photoCount,
  videoCount,
} from "./styles.module.scss"
import { childImageSharpType } from "../../../../shared-prop-types"

const ImageWithCount = ({
  img,
  alt,
  count,
  hasVideo,
  classNames: { container, image },
}) => (
  <div className={classNames(imageWithCountContainer, container)}>
    <GatsbyImage
      image={img.childImageSharp?.gatsbyImageData}
      alt={alt}
      className={classNames(imageStyles, image)}
    />
    {hasVideo && <VideoCount count={1} className={classNames(videoCount)} />}
    <PhotoCount count={count} className={classNames(photoCount)} />
  </div>
)

ImageWithCount.propTypes = {
  img: childImageSharpType.isRequired,
  alt: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  hasVideo: PropTypes.bool.isRequired,
  classNames: PropTypes.shape({
    container: PropTypes.string,
    image: PropTypes.string,
  }),
}

ImageWithCount.defaultProps = {
  classNames: {},
}

export default ImageWithCount
